import axios from "axios";

export const LOGIN_URL = "api/login/";
export const REGISTER_URL = "api/users/";
export const REQUEST_PASSWORD_URL = "api/password_reset/";
export const REFRESH_TOKEN_URL = '/api/refresh/';

export const ME_URL = "api/users/me/";

export function login(username, password) {
  return axios.post(LOGIN_URL, { username, password });
}

export function register(email, first_name, last_name, username, password) {
  return axios.post(REGISTER_URL, { email, first_name, last_name, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
